<template>
	<div class="v-chart" :style="style"></div>
</template>

<script>
export default {
  props: {
    option: {
      default() {
        return {};
      }
    },
    width: {
      default: 300
    },
    height: {
      default: 300
    }
  },
  data() {
    return {
      chart: null
    };
  },
  computed: {
    style() {
      return {
        width: String.unit(this.width, "px"),
        height: String.unit(this.height, "px")
      };
    }
  },
  watch: {
    ["option"](value) {
      this.chart.setOption(value);
    }
  },
  mounted() {
    (this.chart = echarts.init(this.$el)).setOption(this.option);
  }
};
</script>

<style lang="less">
.v-chart {
  display: inline-block;
}
</style>
